import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import { authFetch } from "../utils/authFetch";

const Dashboard = () => {
  const [data, setData] = useState({
    total_amount: 0,
    total_success_amount: 0,
    total_pending_amount: 0,
    total_failed_amount: 0,
    lastTenPayinTransactions: [],
    lastTenPayoutTransactions: [],
    lastTenPanTransactions: [],
    top_users:[],
    total_payin_wallet:[],
    total_main_wallet:[],
    payin_stats: {},
    // payin_stats:[],
    // payout_stats:[],
    payout_stats: {},
    pan_stats: {},
    // pan_stats:[],
    today_payin_breakdown:{},
    // today_payin_breakdown:[],
    today_payout_breakdown:{},
    today_pan_breakdown:{},
    transaction_ratio: {},
    browser_stats: [],
    login_history:[],
    device_stats: {},
  });

  
  const [activeTab, setActiveTab] = useState("payout");
  const [stats, setStats] = useState({});
  const [activeFilter, setActiveFilter] = useState("today");

  useEffect(() => {
    // document.title = "Dashboard | Suvidha";
    const token = localStorage.getItem("token");

    authFetch("/api/v1/dashboard/data", {
      // headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => res.json())
      .then(setData)
      .catch(console.error);

    authFetch("/api/v1/dashboard/stats", {
      // headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => res.json())
      .then(setStats)
      .catch(console.error);
  }, []);

  const getPrefix = () => {
    if (activeFilter === "month") return "month";
    if (activeFilter === "lastmonth") return "lastmonth";
    return "today";
  };

  const chartOptions = {
    chart: {
      id: 'multi-line-chart',
      toolbar: { show: false },
    },
    stroke: {
      curve: 'smooth',
      width: 3,
    },
    xaxis: {
      categories: ['Success', 'Pending', 'Failed'],
    },
    markers: {
      size: 5,
    },
    legend: {
      position: 'top',
    },
  };

  const chartSeries = [
    {
      name: 'PayIn',
      data: [
        stats[`${getPrefix()}successpayin`] || 0,
        stats[`${getPrefix()}pendingpayin`] || 0,
        stats[`${getPrefix()}failedpayin`] || 0,
      ],
    },
    {
      name: 'PayOut',
      data: [
        stats[`${getPrefix()}successpayout`] || 0,
        stats[`${getPrefix()}pendingpayout`] || 0,
        stats[`${getPrefix()}failedpayout`] || 0,
      ],
    },
    {
      name: 'Pan',
      data: [
        stats[`${getPrefix()}successpan`] || 0,
        stats[`${getPrefix()}pendingpan`] || 0,
        stats[`${getPrefix()}failedpan`] || 0,
      ],
    },
  ];

  // const transactions =
  //   activeTab === "payin"
  //     ? data.lastTenPayinTransactions
  //     : data.lastTenPayoutTransactions;

  const transactions =
    activeTab === "payin"
      ? data.lastTenPayinTransactions
      : activeTab === "payout"
      ? data.lastTenPayoutTransactions
      // : activeTab === "pan"
      : data.lastTenPanTransactions;
      

  const ratioOptions = {
    chart: {
      type: "pie",
    },

    labels: ["Success", "Pending", "Failed"],

    colors: ["#7d00b5", "#ff8b01", "#ff007c"],

    legend: {
      position: "bottom",
      // labels: {
      //   colors: "#333"
      // }
    },

    dataLabels: {
      enabled: true
    },

    // states: {
    //   hover: {
    //     filter: {
    //       type: "lighten",
    //       value: 0.1
    //     }
    //   }
    // },

    // tooltip: {
    //   theme: "dark"
    // }
  };
  
  const ratioSeries = [
    data?.transaction_ratio?.success_ratio ?? 0,
    data?.transaction_ratio?.pending_ratio ?? 0,
    data?.transaction_ratio?.failed_ratio ?? 0
  ];

  const deviceOptions = {
    chart: { type: "donut" },
    labels: ["Mobile", "Desktop", "Tablet"],
    colors: ["#dc3545", "#0d6efd", "#ffc107"],
    legend: { position: "bottom" }
  };

  const deviceSeries = [
    data?.device_stats?.Mobile || 0,
    data?.device_stats?.Desktop || 0,
    data?.device_stats?.Tablet || 0
  ];

  const browserIcons = {
    Chrome: "/assets/images/icons/chrome.png",
    Firefox: "/assets/images/icons/firefox.png",
    Edge: "/assets/images/icons/edge.png",
    Opera: "/assets/images/icons/opera.png",
    Safari: "/assets/images/icons/safari.png",
    HiBrowser: "/assets/images/icons/hibrowser.webp", // fallback
    Default: "/assets/images/icons/browser.jpg"
  };

  const combinedSeries = [
  {
    name: "Payin",
    data: [
      data.payin_stats?.total_success_amount || 0,
      data.payin_stats?.total_failed_amount || 0,
    ],
  },
  {
    name: "Payout",
    data: [
      data.payout_stats?.total_success_amount || 0,
      data.payout_stats?.total_failed_amount || 0,
    ],
  },
  {
    name: "PAN",
    data: [
      data.pan_stats?.total_success_amount || 0,
      data.pan_stats?.total_failed_amount || 0,
    ],
  },
];

const combinedOptions = {
  chart: { type: "bar" },
  xaxis: {
    categories: ["Success", "Failed"],
  },
};    

    return(
        <>
        <div className="page-wrapper">
        {/*page-content-wrapper*/}
        <div className="page-content-wrapper">
          <div className="page-content">
            <div className="row">
              <div className="col-12 col-lg-3">
                <div className="card radius-15 bg-voilet">
                  <div className="card-body">
                    <div className="d-flex align-items-center">
                      <div>
                        <h3 className="mb-0 text-white">₹{data.total_amount || 0} <i className="bx bxs-up-arrow-alt font-14 text-white" /> </h3>
                      </div>
                      <div className="ms-auto font-35 text-white"><i className="bx bx-cart-alt" />
                      </div>
                    </div>
                    <div className="d-flex align-items-center">
                      <div>
                        <p className="mb-0 text-white">Total Transactions</p>
                      </div>
                      <div className="ms-auto font-14 text-white">+23.4%</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-lg-3">
                <div className="card radius-15 bg-primary-blue">
                  <div className="card-body">
                    <div className="d-flex align-items-center">
                      <div>
                        <h3 className="mb-0 text-white">₹{data.total_success_amount} <i className="bx bxs-down-arrow-alt font-14 text-white" /> </h3>
                      </div>
                      <div className="ms-auto font-35 text-white"><i className="bx bx-support" />
                      </div>
                    </div>
                    <div className="d-flex align-items-center">
                      <div>
                        <p className="mb-0 text-white">Successful Transactions</p>
                      </div>
                      <div className="ms-auto font-14 text-white">+14.7%</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-lg-3">
                <div className="card radius-15 bg-rose">
                  <div className="card-body">
                    <div className="d-flex align-items-center">
                      <div>
                        <h3 className="mb-0 text-white">₹{data.total_pending_amount} <i className="bx bxs-up-arrow-alt font-14 text-white" /> </h3>
                      </div>
                      <div className="ms-auto font-35 text-white"><i className="bx bx-tachometer" />
                      </div>
                    </div>
                    <div className="d-flex align-items-center">
                      <div>
                        <p className="mb-0 text-white">Pending Transactions</p>
                      </div>
                      <div className="ms-auto font-14 text-white">-12.9%</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-lg-3">
                <div className="card radius-15 bg-sunset">
                  <div className="card-body">
                    <div className="d-flex align-items-center">
                      <div>
                        <h3 className="mb-0 text-white">₹{data.total_failed_amount} <i className="bx bxs-up-arrow-alt font-14 text-white" /> </h3>
                      </div>
                      <div className="ms-auto font-35 text-white"><i className="bx bx-user" />
                      </div>
                    </div>
                    <div className="d-flex align-items-center">
                      <div>
                        <p className="mb-0 text-white">Failed Transactions</p>
                      </div>
                      <div className="ms-auto font-14 text-white">+13.6%</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/*end row*/}
            <div className='row'>
              <div className='col-12 col-lg-12 col-xl-6 d-flex'>
                <div className="card radius-15 w-100">
                  <div className="card-header border-bottom-0">
                    <div className="d-lg-flex align-items-center">
                      <div>
                        <h5 className="mb-2 mb-lg-0">Transaction Update</h5>
                      </div>
                      <div className="ms-lg-auto mb-2 mb-lg-0">
                        <div className="btn-group-round">
                          <div className="btn-group">
                          <button
                            type="button"
                            className={`btn btn-white ${activeFilter === "today" ? "active" : ""}`}
                            onClick={() => setActiveFilter("today")}
                          >
                            Daily
                          </button>
                          <button
                            type="button"
                            className={`btn btn-white ${activeFilter === "month" ? "active" : ""}`}
                            onClick={() => setActiveFilter("month")}
                          >
                            Monthly
                          </button>
                          <button
                            type="button"
                            className={`btn btn-white ${activeFilter === "lastmonth" ? "active" : ""}`}
                            onClick={() => setActiveFilter("lastmonth")}
                          >
                            Last Month
                          </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <Chart
                        options={chartOptions}
                        series={chartSeries}
                        type="line"
                        height={350}
                      />
                  </div>
                </div>
              </div>
              <div className='col-12 col-lg-12 col-xl-6 d-flex'>
                <div className="card radius-15 w-100">
                  <div className="card-body">
                    <h5>Service Comparison</h5>
                    <Chart
                      options={combinedOptions}
                      series={combinedSeries}
                      type="bar"
                      height={300}
                    />
                  </div>
                </div>
              </div>
            </div>
            
            <div className="row">
              <div className="col-12 col-lg-12 col-xl-4 d-flex">
                <div className="card radius-15 w-100">
                  <div className="card-body">
                      <div>
                        <h5 className="mb-3">Todays Total Payout  </h5>
                      </div>
                    <div className="row row-cols-1 row-cols-md-3 g-3">
                      <div className="col">
                        <div className="card radius-15 mb-0 shadow-none border">
                          <div className="card-body text-center">
                            <div className="widgets-icons mx-auto rounded-circle bg-success text-white"><i className="bx bx-line-chart" />
                            </div>
                            <h6 className="mb-0 font-weight-bold mt-3">{(Number(data.today_payout_breakdown['success']) || 0).toFixed(2)}</h6>
                            <p className="mb-0">Total Success</p>
                          </div>
                        </div>
                      </div>
                      <div className="col">
                        <div className="card radius-15 mb-0 shadow-none border">
                          <div className="card-body text-center">
                            <div className="widgets-icons mx-auto bg-warning rounded-circle text-white"><i className="bx bx-group" />
                            </div>
                            <h6 className="mb-0 font-weight-bold mt-3">{(Number(data.today_payout_breakdown['pending']) || 0).toFixed(2)}</h6>
                            <p className="mb-0">Total Pending</p>
                          </div>
                        </div>
                      </div>
                      <div className="col">
                        <div className="card radius-15 mb-0 shadow-none border">
                          <div className="card-body text-center">
                            <div className="widgets-icons mx-auto bg-danger text-white rounded-circle"><i className="bx bx-cloud-download" />
                            </div>
                            <h6 className="mb-0 font-weight-bold mt-3">{(Number(data.today_payout_breakdown['failed']) || 0).toFixed(2)}</h6>
                            <p className="mb-0">Total Failed</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-lg-12 col-xl-4 d-flex">
                <div className="card radius-15 w-100">
                  <div className="card-body">
                      <div >
                        <h5 className="mb-3">Todays Total Payin </h5>
                      </div>
                    <div className="row row-cols-1 row-cols-md-3 g-3">
                      <div className="col">
                        <div className="card radius-15 mb-0 shadow-none border">
                          <div className="card-body text-center">
                            <div className="widgets-icons mx-auto rounded-circle bg-success text-white"><i className="bx bx-time" />
                            </div>
                            <h6 className="mb-0 font-weight-bold mt-3">{(Number(data.today_payin_breakdown['success']) || 0).toFixed(2)}</h6>
                            <p className="mb-0">Total Success</p>
                          </div>
                        </div>
                      </div>
                      <div className="col">
                        <div className="card radius-15 mb-0 shadow-none border">
                          <div className="card-body text-center">
                            <div className="widgets-icons mx-auto bg-warning text-white rounded-circle"><i className="bx bx-bookmark-alt" />
                            </div>
                            <h6 className="mb-0 font-weight-bold mt-3">{(Number(data.today_payin_breakdown['pending']) || 0).toFixed(2)}</h6>
                            <p className="mb-0">Total Pending</p>
                          </div>
                        </div>
                      </div>
                      <div className="col">
                        <div className="card radius-15 mb-0 shadow-none border">
                          <div className="card-body text-center">
                            <div className="widgets-icons mx-auto bg-danger rounded-circle text-white"><i className="bx bx-bulb" />
                            </div>
                            <h6 className="mb-0 font-weight-bold mt-3">{(Number(data.today_payin_breakdown['failed']) || 0).toFixed(2)}</h6>
                            <p className="mb-0">Total Failed</p>
                          </div>
                        </div>
                      </div>
                      
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-lg-12 col-xl-4 d-flex">
                <div className="card radius-15 w-100">
                  <div className="card-body">
                      <div>
                        <h5 className="mb-3">Todays Total PAN  </h5>
                      </div>
                    <div className="row row-cols-1 row-cols-md-3 g-3">
                      <div className="col">
                        <div className="card radius-15 mb-0 shadow-none border">
                          <div className="card-body text-center">
                            <div className="widgets-icons mx-auto rounded-circle bg-success text-white"><i className="bx bx-line-chart" />
                            </div>
                            <h6 className="mb-0 font-weight-bold mt-3">{(Number(data.today_pan_breakdown['success']) || 0).toFixed(2)}</h6>
                            <p className="mb-0">Total Success</p>
                          </div>
                        </div>
                      </div>
                      <div className="col">
                        <div className="card radius-15 mb-0 shadow-none border">
                          <div className="card-body text-center">
                            <div className="widgets-icons mx-auto bg-warning rounded-circle text-white"><i className="bx bx-group" />
                            </div>
                            <h6 className="mb-0 font-weight-bold mt-3">{(Number(data.today_pan_breakdown['pending']) || 0).toFixed(2)}</h6>
                            <p className="mb-0">Total Pending</p>
                          </div>
                        </div>
                      </div>
                      <div className="col">
                        <div className="card radius-15 mb-0 shadow-none border">
                          <div className="card-body text-center">
                            <div className="widgets-icons mx-auto bg-danger text-white rounded-circle"><i className="bx bx-cloud-download" />
                            </div>
                            <h6 className="mb-0 font-weight-bold mt-3">{(Number(data.today_pan_breakdown['failed']) || 0).toFixed(2)}</h6>
                            <p className="mb-0">Total Failed</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="row ">
              <div className="col-12 col-lg-3 d-flex">
                <div className="card radius-15 w-100">
                  <div className="card-body">
                    <div className="d-lg-flex align-items-center mb-4">
                      <h5 className="mb-0">Top Users Txn List</h5>
                    </div>

                    {data.top_users && data.top_users.length > 0 ? (
                      data.top_users.map((user, index) => {
                        // multi-color array
                        const colors = [
                          "progress-bar progress-bar-striped progress-bar-animated",
                          "bg-success progress-bar-striped progress-bar-animated",
                          "bg-warning progress-bar-striped progress-bar-animated",
                          "bg-danger progress-bar-striped progress-bar-animated",
                          "bg-info progress-bar-striped progress-bar-animated",
                          "bg-purple progress-bar-striped progress-bar-animated",
                        ];
                        const barColor = colors[index % colors.length]; // rotate colors
                        const percent = Math.round(user.percentage); // directly from API response

                        return (
                          <div className="progress-wrapper mb-3" key={user.user_id}>
                            {/* <p className="mb-1">
                              {user.name || user.merchantcode}{" "}
                              <span className="float-end">{percent}%</span>
                            </p> */}
                            <p className="mb-1">
                              <span className="fw-bold">{user.name}</span>
                              {/* <small className="text-muted ms-2" style={{ fontSize: "10px" }}>({user.merchantcode})</small> */}
                              <span className="float-end">{percent}%</span>
                            </p>
                            <div className="progress radius-15" style={{ height: "5px" }}>
                              <div
                                className={`progress-bar ${barColor}`}
                                role="progressbar"
                                style={{ width: `${percent}%` }}
                              />
                            </div>
                            <small className="text-muted">
                              {/* ₹  */}
                              {/* {user.amount}  */}
                              ({user.count} txns)
                            </small>
                          </div>
                        );
                      })
                    ) : (
                      <p className="text-center">No users found</p>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-12 col-lg-6 d-flex">
                <div className="card radius-15 w-100">
                  <div className="card-body">
                    <div className="d-flex align-items-center mb-3">
                      <div>
                        <h5 className="mb-0">Wallet Balance With Profit </h5>
                      </div>
                      <div className="dropdown ms-auto d-none">
                        <div className="cursor-pointer text-dark font-24 dropdown-toggle dropdown-toggle-nocaret" data-bs-toggle="dropdown"><i className="bx bx-dots-horizontal-rounded" />
                        </div>
                        <div className="dropdown-menu dropdown-menu-right">	<a className="dropdown-item" href="javascript:;">Action</a>
                          <a className="dropdown-item" href="javascript:;">Another action</a>
                          <div className="dropdown-divider" />	<a className="dropdown-item" href="javascript:;">Something else here</a>
                        </div>
                      </div>
                    </div>
                    <div className="row g-3">
                      <div className="col-12 col-lg-6">
                        <div className="card radius-15 border shadow-none mb-0">
                          <div className="card-body">
                            <div className="d-flex flex-row align-items-center">
                              <div>
                                <p className="text-secondary mb-0">Todays PayIn Wallet</p>
                                {/* <h4 className="mb-0">{data.total_payin_wallet.toFixed(2)}</h4> */}
                                <h4 className="mb-0">{(Number(data.today_payin_total) || 0).toFixed(2)}</h4>
                              </div>
                              <div className="fs-2 ms-auto">
                                <i className="bx bx-sort-up" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-lg-6">
                        <div className="card radius-15 border shadow-none mb-0">
                          <div className="card-body">
                            <div className="d-flex flex-row align-items-center">
                              <div>
                                <p className="text-secondary mb-0">Todays Payout Wallet</p>
                                {/* <h4 className="mb-0">{data.total_payin_wallet.toFixed(2)}</h4> */}
                                <h4 className="mb-0">{(Number(data.today_payout_total) || 0).toFixed(2)}</h4>
                              </div>
                              <div className="fs-2 ms-auto">
                                <i className="bx bx-sort-down" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-lg-6">
                        <div className="card radius-15 border shadow-none mb-0">
                          <div className="card-body">
                            <div className="d-flex flex-row align-items-center">
                              <div>
                                <p className="text-secondary mb-0">Total PayIn Wallet</p>
                                {/* <h4 className="mb-0">{data.total_payin_wallet.toFixed(2)}</h4> */}
                                <h4 className="mb-0">{(Number(data.total_payin_wallet) || 0).toFixed(2)}</h4>
                              </div>
                              <div className="fs-2 ms-auto">
                                <i className="bx bx-upvote" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-lg-6">
                        <div className="card radius-15 border shadow-none mb-0">
                          <div className="card-body">
                            <div className="d-flex flex-row align-items-center">
                              <div>
                                <p className="text-secondary mb-0">Total PayOut Wallet</p>
                                {/* <h4 className="mb-0">{data.total_main_wallet.toFixed(2)}</h4> */}
                                <h4 className="mb-0">{(Number(data.total_main_wallet) || 0).toFixed(2)}</h4>
                              </div>
                              <div className="fs-2 ms-auto">
                                <i className="bx bx-downvote" />
                                {/* <i className="bx bx-wallet-alt" /> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-lg-6">
                        <div className="card radius-15 border shadow-none mb-0">
                          <div className="card-body">
                            <div className="d-flex flex-row align-items-center">
                              <div>
                                <p className="text-secondary mb-0">PayIn Profit</p>
                                <h4 className="mb-0">
                                  {((data.payin_stats?.total_success_amount || 0) - (data.payin_stats?.total_failed_amount || 0)).toFixed(2)}
                                </h4>
                              </div>
                              <div className="fs-2 ms-auto">
                                <i className="bx bx-trending-up" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-lg-6">
                        <div className="card radius-15 border shadow-none mb-0">
                          <div className="card-body">
                            <div className="d-flex flex-row align-items-center">
                              <div>
                                <p className="text-secondary mb-0">PayOut Profit</p>
                                <h4 className="mb-0">
                                  {((data.payout_stats?.total_success_amount || 0) - (data.payout_stats?.total_failed_amount || 0)).toFixed(2)}
                                </h4>
                              </div>
                              <div className="fs-2 ms-auto">
                                <i className="bx bx-trending-down" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-lg-6">
                        <div className="card radius-15 border shadow-none mb-0">
                          <div className="card-body">
                            <div className="d-flex flex-row align-items-center">
                              <div>
                                <p className="text-secondary mb-0">PAN Profit</p>
                                <h4 className="mb-0">
                                  {((data.pan_stats?.total_success_amount || 0) - 
                                    (data.pan_stats?.total_failed_amount || 0)).toFixed(2)}
                                </h4>
                              </div>
                              <div className="fs-2 ms-auto">
                                <i className="bx bx-trending-up" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-lg-3 d-flex">
                <div className="card radius-15 w-100">
                  <div className="card-body">
                    <div className="card-title">
                      <h5 className="mb-0">Transaction Ratio</h5>
                    </div>
                    <hr/>

                    <Chart
                      options={ratioOptions}
                      series={ratioSeries}
                      type="pie"
                      height={270}
                    />
                    
                    <ul className="list-group list-group-flush mb-0 mt-3">
                      <li className="list-group-item border-top d-flex justify-content-between align-items-center bg-transparent">
                        Success
                        <span className="badge bg-voilet rounded-pill">
                          {data?.transaction_ratio?.success_ratio || 0}%
                        </span>
                      </li>

                      <li className="list-group-item d-flex justify-content-between align-items-center bg-transparent">
                        Pending
                        <span className="badge bg-sunset rounded-pill">
                          {data?.transaction_ratio?.pending_ratio || 0}%
                        </span>
                      </li>

                      <li className="list-group-item d-flex justify-content-between align-items-center bg-transparent">
                        Failed
                        <span className="badge bg-rose rounded-pill text-dark">
                          {data?.transaction_ratio?.failed_ratio || 0}%
                        </span>
                      </li>
                    </ul>

                  </div>
                </div>
              </div>
            </div>
            {/*end row*/}
            
            {/*end row*/}
            <div className="card radius-15 overflow-hidden ">
              <div className="card-header border-bottom-0">
                <div className="d-flex align-items-center">
                  <div>
                    <h5 className="mb-0">Recent Transactions</h5>
                  </div>
                  <div className="ms-auto dropdown">
                      <button
                        className="btn btn-white btn-sm px-4 radius-15 dropdown-toggle"
                        type="button"
                        id="dropdownMenuButton"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        {/* {activeTab === "payout" ? "Payout" : "Payin"} */}
                        {activeTab === "payout"
                          ? "Payout"
                          : activeTab === "payin"
                          ? "Payin"
                          : "Pan"
                        }
                      </button>
                      <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                        <li>
                          <button
                            className={`dropdown-item ${activeTab === "payout" ? "active" : ""}`}
                            onClick={() => setActiveTab("payout")}
                          >
                            Payout
                          </button>
                        </li>
                        <li>
                          <button
                            className={`dropdown-item ${activeTab === "payin" ? "active" : ""}`}
                            onClick={() => setActiveTab("payin")}
                          >
                            Payin
                          </button>
                        </li>
                        <li>
                          <button
                            className={`dropdown-item ${activeTab === "pan" ? "active" : ""}`}
                            onClick={() => setActiveTab("pan")}
                          >
                            Pan
                          </button>
                        </li>
                      </ul>
                  </div>
                </div>
              </div>
              <div className="card-body p-0">
                <div className="table-responsive">
                  <table className="table mb-0">
                    <thead>
                      <tr>
                        <th>Sr No.</th>
                        <th>Txn ID</th>
                        <th>Date</th>
                        <th>Amount</th>
                        <th>UTR</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {transactions.length > 0 ? (
                        transactions.map((tx, index) => (
                          <tr key={tx._id}>
                            <td>{index + 1}</td>
                            <td>{tx.txnid}</td>
                            <td>{new Date(tx.created_at).toLocaleDateString()}</td>
                            <td>{tx.amount}</td>
                            <td>{tx.payid || "N/A"}</td>
                            {/* <td>{tx.api_response?.data?.[0]?.utr || "N/A"}</td> */}
                            <td>
                              <span
                                className={`btn btn-sm ${
                                  tx.status === "success"
                                    ? "btn-light-success"
                                    : tx.status === "pending"
                                    ? "btn-light-warning"
                                    : "btn-light-danger"
                                } btn-block radius-30`}
                              >
                                {tx.status.charAt(0).toUpperCase() + tx.status.slice(1)}
                              </span>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={6} className="text-center">
                            No transactions found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div className='row'>
              <div className='col-12 col-lg-3 d-flex'>
                <div class="card radius-15 w-100">
                  <div class="card-body">
                    <div class="card-title">
                      <h5 class="mb-0">Browser Statistics </h5>
                    </div>
                    <hr/>
                    {data.browser_stats.map((b, i) => (
                      <div key={i}>
                        <div className="d-flex align-items-center gap-3">

                          <div>
                            <img
                              src={browserIcons[b.browser] || browserIcons.Default}
                              width="35"
                              height="35"
                              alt=""
                            />
                          </div>

                          <div>
                            <h6 className="mb-0">{b.count}</h6>
                            <p className="mb-0">{b.browser}</p>
                          </div>

                          <p className="mb-0 ms-auto">{b.percentage}%</p>
                        </div>

                        <hr />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className='col-12 col-lg-6 d-flex'>
                <div class="card radius-15 w-100">
                  <div class="card-body">
                    <div class="card-title">
                      <h5 class="mb-0">Login History</h5>
                    </div>
                    <hr/>
                    <div class="table-responsive">
                      <table class="table table-striped">
                        <thead>
                          <tr>
                            <th scope="col">#</th>
                            <th scope="col">Date Time</th>
                            <th scope="col">User</th>
                            <th scope="col">IP Address</th>
                          </tr>
                        </thead>
                        <tbody>
                        {data.login_history?.map((row, i) => (
                          <tr key={i}>
                            <td>{i + 1}</td>
                            <td>{row.login_time}</td>
                            <td>{row.user_id}</td>
                            <td>{row.ip_address}</td>
                          </tr>
                        ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
					      </div>
              </div>
              <div className='col-12 col-lg-3 d-flex d-none'>
                <div class="card radius-15 w-100">
								<div class="card-body">
									<div class="d-lg-flex align-items-center">
										<div>
											<h5 class="mb-0">Devices of Visitors</h5>
										</div>
									</div>
									<div id="chart5"></div>
								</div>
								<Chart
                  options={deviceOptions}
                  series={deviceSeries}
                  type="donut"
                  height={220}
                />
							</div>
              </div>

              <div className="col-12 col-lg-3 d-flex">
                <div className="card radius-15 w-100">
                  <div className="card-body">
                    <div className="card-title">
                      <h5 className="mb-0">Devices of Visitors</h5>
                    </div>
                    <hr/>
                    <Chart
                      options={deviceOptions}
                      series={deviceSeries}
                      type="donut"
                      height={270}
                    />
                    <ul className="list-group list-group-flush mb-0 mt-3">
                      <li className="list-group-item border-top d-flex justify-content-between align-items-center bg-transparent">
                        Mobile
                        <span className="badge bg-danger rounded-pill">
                          {data?.device_stats?.Mobile || 0}%
                        </span>
                      </li>

                      <li className="list-group-item d-flex justify-content-between align-items-center bg-transparent">
                        Desktop
                        <span className="badge bg-primary rounded-pill">
                          {data?.device_stats?.Desktop || 0}%
                        </span>
                      </li>

                      <li className="list-group-item d-flex justify-content-between align-items-center bg-transparent">
                        Tablet
                        <span className="badge bg-warning rounded-pill text-dark">
                          {data?.device_stats?.Tablet || 0}%
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

            </div>
            
          </div>
          
        </div>
        {/*end page-content-wrapper*/}
      </div>
        </>
    )
}


export default Dashboard